import { type FunctionComponent } from 'react';
import { type CommonPromoFieldsFragment } from '../../../__generated__/graphql-client-types';
import { type CategoryBrowseContent } from '../../../types/content.types';
import { type Category } from '../../../types/search.types';
import { ContentContainer } from '../../content-container/content-container.component';
import { PromoBanner } from '../../promo-banner/promo-banner.component';
import { LoadableCategoryContent } from '../category-content/loadable-category-content.component';
import { CategoriesSection } from './main-browse-components/categories-section/categories-section.component';
import { ShopBySection } from './main-browse-components/shop-by-section/shop-by-section.component';

export type MainBrowseProps = {
	category: Category;
	categoryType: string;
	categoryBrandName: string | null;
	topPromo?: CommonPromoFieldsFragment;
	bottomPromo?: CommonPromoFieldsFragment;
	content: CategoryBrowseContent | null;
};

export const MainBrowse: FunctionComponent<MainBrowseProps> = ({
	category,
	categoryType,
	categoryBrandName,
	topPromo,
	bottomPromo,
	content
}) => {
	// Lists for featured vs normal subcategories
	const featuredCategories = category.subCategories?.filter(({ isFeatured }) => isFeatured) || [];
	const nonFeaturedCategories = category.subCategories?.filter(({ isFeatured }) => !isFeatured) || [];

	const { brandCopy } = content || {};
	const shouldShowBrandCopy = Boolean(content?.id && brandCopy);

	return (
		<div className="w-100 w-75-l ml2-l">
			{/* Category title here for brand pages */}
			{categoryBrandName && <h1 className={'dib ma0 mb4'}>{category.name}</h1>}
			{/* BRAND COPY */}
			{shouldShowBrandCopy && (
				<ContentContainer contentId={content?.id || ''}>
					<p>{brandCopy}</p>
				</ContentContainer>
			)}
			{/* Category Promo Banner (Construct) */}
			{topPromo && <PromoBanner {...topPromo} />}
			{/* Featured Categories */}
			<CategoriesSection categories={featuredCategories} isFeatured={true} />
			<div id={`dy-recs-${categoryType}-browse-page-2`} data-testid="dy-recs-placement-2" />
			{/* Shop By Section */}
			<ShopBySection categories={content?.categories} />
			{/* NonFeatured Categories (small displays) */}
			<CategoriesSection categories={nonFeaturedCategories} categoryName={category.name} isFeatured={false} />
			{/* Lazy Loaded Category Content */}
			<LoadableCategoryContent content={content} categoryName={category.name} promo={bottomPromo} />
		</div>
	);
};
